<div class="title-container">
  <mds-icon [key]="appDetails.icon" [width]="appDetails.iconWidth" [height]="appDetails.iconHeight" [pathColors]="[appDetails.iconColor]"></mds-icon>
  <h4 [ngClass]="appDetails.cssClass">{{appDetails.appName}}</h4>

  @if (appDetails.isRightIcon) {
    <button
      class="right-button"
      [matMenuTriggerFor]="checkboxMenu"
      matMenuTriggerPosition="below"
      aria-label="Favorite apps options"
      >
      <mds-icon [key]="appDetails.rightIconDetails.name"></mds-icon>
    </button>
  }

  <mat-menu #checkboxMenu="matMenu" class="custom-menu">
    <div (click)="$event.stopPropagation()">
      <app-list-search-checkbox
        [list]="extraData?.list"
        [selectedList]="extraData?.selectedList"
        (refreshFavorite)="handleFavoriteUpdate($event)"
        >
      </app-list-search-checkbox>
    </div>

  </mat-menu>
</div>
